// Cookie consent state (UK PECR / UK GDPR). Stored locally and broadcast so the
// tracker loaders and the footer "Cookie Settings" link can react to changes.
const KEY = "ss_cookie_consent_v1";
export const CONSENT_EVENT = "ss-cookie-consent-changed";

export function getConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setConsent(categories) {
  const value = {
    necessary: true,
    analytics: !!categories.analytics,
    marketing: !!categories.marketing,
    timestamp: new Date().toISOString(),
    version: 1,
  };
  try {
    localStorage.setItem(KEY, JSON.stringify(value));
  } catch {
    /* storage unavailable — consent simply won't persist */
  }
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: value }));
  return value;
}

export function hasConsent(category) {
  const c = getConsent();
  return !!(c && c[category]);
}
